import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
     button: {
        textTransform: 'none',
        height: '50px',
        fontSize: '17px',
        marginTop: '10px'
    }
}))